// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"rename"},"children":[{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16.5 3V21M16.5 3H14M16.5 3H19M16.5 21H19M16.5 21H14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11 7H1V17H11M22 7H23V17H22M5 12H9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const RenameIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'rename',
    ref,
    icon: element,
  },
));

RenameIcon.displayName = 'RenameIcon';

export default RenameIcon;
